import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faMicrochip,
  faUsers,
  faKey,
  faFileCode,
} from '@fortawesome/free-solid-svg-icons';

export default function PartnerNav() {
  const navItems = [
    {
      to: '/partner',
      label: 'Dashboard',
      icon: faTachometerAlt,
      end: true,
    },
    {
      to: '/partner/devices',
      label: 'Devices',
      icon: faMicrochip,
    },
    {
      to: '/partner/customers',
      label: 'Customers',
      icon: faUsers,
    },
    {
      to: '/settings/api-keys',
      label: 'API Keys',
      icon: faKey,
    },
    {
      to: '/partner/api-docs',
      label: 'API Docs',
      icon: faFileCode,
    },
  ];

  return (
    <nav className="flex-1 px-4 py-4 space-y-2">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
              isActive
                ? 'bg-blue-50 text-blue-700'
                : 'text-gray-700 hover:bg-gray-50'
            }`
          }
        >
          <FontAwesomeIcon icon={item.icon} className="h-5 w-5 mr-3" />
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
